// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FvOb","placeholdersHeader":"styles_placeholdersHeader__3_DbY","editorStyle":"styles_editorStyle__3f5XR","placeholdersBox":"styles_placeholdersBox__BYiLN"};